import { combineReducers } from "@reduxjs/toolkit";

import { connectRouter } from "connected-react-router";
import common from "./common";
import auth from "./auth";
import subscriptions from "./subscriptions";
import clients from "./clients";
import address from "./address";
import productions from "./productions";
import catalogs from "./catalogs";
import meals from "./meals";
import deliveryOrder from "./deliveryOrder";
import clientOrder from "./clientOrder";
import createSubscription from "./createSubscription";
import consultation from "./consultation";
import { History } from "history";
import expressOrder from "./expressOrder";
import configuration from "./configuration";
import products from "./products";
import analytics from "../slice/analyticsSlice";
import distribution from "../slice/distributionSlice";
import distributionDriver from "../slice/distributionDriverSlice";
import distributionDeliveries from "../slice/distributionDeliveriesSlice";
import plannedDeliveries from "../slice/plannedDeliveriesSlice";
import customerSupport from "../slice/customerSupportSlice";
import subscriptionsManager from "../slice/subscriptionsManagerSlice";
import clientsSlice from "../slice/clientsSlice";
import promotions from "../slice/promotionsSlice";
import promotionsGroup from "../slice/promotionsGroupSlice";
import mealsSlice from "../slice/mealsSlice";
import catalogsSlice from "../slice/catalogsSlice";
import subscriptionTransfer from "../slice/subscriptionTransferSlice";
import groups from "../slice/groupsSlice";
import packages from "../slice/packagesSlice";
import pricePlans from "../slice/pricePlansSlice";
import report from "../slice/reportSlice";
import wallets from "../slice/walletsSlice";
import permissions from "../slice/permissionsSlice";
import  allergies from "../slice/allergiesSlice";
import mealRatings from "../slice/mealRatingSlice";
import customMeals from "../slice/customMealsSlice";
import configurationSlice from "../slice/configurationSlice";
import notificationCampaign from "../slice/notificationCampaignSlice";
import lightfieldsAnalytics from "../slice/lightfieldsAnalyticsSlice";
import catalogImport from "../slice/catalogImportSlice";
import catalogImportLogs from "../slice/catalogImportLogsSlice";
import productVariants from "../slice/productVariantsSlice";

const exportReducers = (history: History) => {
  return combineReducers({
    router: connectRouter(history),
    common,
    auth,
    subscriptions,
    clients,
    clientsSlice,
    address,
    productions,
    catalogs,
    meals,
    deliveryOrder,
    clientOrder,
    createSubscription,
    consultation,
    expressOrder,
    configuration,
    products,
    analytics,
    distribution,
    distributionDriver,
    distributionDeliveries,
    plannedDeliveries,
    customerSupport,
    subscriptionsManager,
    promotions,
    promotionsGroup,
    mealsSlice,
    catalogsSlice,
    subscriptionTransfer,
    groups,
    packages,
    pricePlans,
    report,
    wallets,
    permissions,
    mealRatings,
    allergies,
    customMeals,
    configurationSlice,
    notificationCampaign,
    lightfieldsAnalytics,
    catalogImport,
    catalogImportLogs,
    productVariants,
  });
};

export default exportReducers;
